<mat-form-field class="w-full" appearance="outline">
  <mat-label>Roles de l'utilisateur</mat-label>
  @if (userRoleRepresentations(); as userRoles) {
    <mat-select
      [formField]="formTree.roles"
      [compareWith]="compareRoles"
      placeholder="Sélectionner les roles"
      multiple
    >
      @for (role of userRoles; track $index) {
        <mat-option [value]="role">
          {{ role.name }}
        </mat-option>
      }
    </mat-select>
  }
</mat-form-field>
